'use client';

import AddIcon from '@mui/icons-material/Add';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import React, { Dispatch, SetStateAction, useRef } from 'react';
import { v4 as uuidv4 } from 'uuid';

import { ContractDocumentsFormData } from '../../../types';

interface UploadContractDocumentProps {
	accountId?: number;
	setFormData: Dispatch<SetStateAction<ContractDocumentsFormData>>;
	setHasUnsavedChanges?: Dispatch<SetStateAction<boolean>>;
	file?: File | null;
	setFile?: Dispatch<SetStateAction<File>>;
}

export const UploadContractDocument = ({
	accountId,
	setFormData,
	setHasUnsavedChanges,
	file,
	setFile,
}: UploadContractDocumentProps) => {
	const uploadDocRef = useRef(null);

	const handleChange = async (event) => {
		const fileToUpload = event.target.files[0];
		setFile(fileToUpload);
		setHasUnsavedChanges(true);
		setFormData((prevData) => ({
			...prevData,
			documentContentType: fileToUpload.type,
			...(!prevData.documentPath && {
				documentPath: `contract-documents/${accountId}/${uuidv4()}`,
			}),
		}));
	};

	return (
		<Box>
			<>
				<Button
					color='primary'
					startIcon={<AddIcon />}
					disabled={!accountId}
					onClick={() => uploadDocRef.current?.click()}
					data-cy='upload-document-button'
				>
					Upload Document
					{file ? <CheckCircleOutlineOutlinedIcon sx={{ paddingLeft: '5px' }} /> : null}
				</Button>
				<input
					onChange={handleChange}
					ref={uploadDocRef}
					type='file'
					style={{ display: 'none' }}
					accept='image/*,.pdf'
					data-cy='upload-contract-document-input'
				/>
			</>
		</Box>
	);
};
